import { API } from "@/lib/api";
import { APIService } from "@/services/api";
import {
  ReadContractorCard,
  UpdateContractorCard,
} from "@/types/contractorCard";

export const ContractorCardsService = new APIService<
  ReadContractorCard,
  UpdateContractorCard
>(API.ContractorCards);

export const fetchContractorCardsList = ContractorCardsService.getList;
export const fetchContractorCard = ContractorCardsService.get;
export const updateContractorCard = ContractorCardsService.patch;
